"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLevelActive = exports.levels = void 0;
exports.levels = [
    { name: 'trace', color: 'lightgray', icon: '✏️', consoleMethod: 'trace' },
    { name: 'debug', color: 'green', icon: '🐸', consoleMethod: 'debug' },
    { name: 'info', color: 'lightblue', icon: '🔵', consoleMethod: 'info' },
    { name: 'warn', color: 'orange', icon: '⚠️', consoleMethod: 'warn' },
    { name: 'error', color: 'red', icon: '‼️', consoleMethod: 'error' },
];
const isLevelActive = (queryLevel, targetLevel) => {
    if (!targetLevel) {
        return true;
    }
    const targetLevelIndex = exports.levels.findIndex(l => l.name === targetLevel);
    const queryLevelIndex = exports.levels.findIndex(l => l.name === queryLevel);
    return queryLevelIndex >= targetLevelIndex;
};
exports.isLevelActive = isLevelActive;
exports.default = exports.levels;
//# sourceMappingURL=levels.js.map